import { FC } from 'react';
import { SbomLibraryItem } from '../sbom-types';
import VulnerabilityGraph from '../../issues/common/components/IssueItem/ScaVulnerabilitiesTable/VulnerabilityGraph';

const SbomCard: FC<React.PropsWithChildren<SbomCardProps>> = props => {
  const { sbom } = props;
  return (
    <div style={{ height: '100%' }}>
      {sbom.dependencyGraphNodes?.length ? (
        <VulnerabilityGraph
          nodes={sbom.dependencyGraphNodes}
          edges={sbom.dependencyGraphEdges}
        />
      ) : null}
    </div>
  );
};

export interface SbomCardProps {
  sbom: SbomLibraryItem;
  height?: number;
}

export default SbomCard;
